module.exports = __webpack_public_path__ + "media/src/images/ms-icon-144x144-e681849e0a05445c11b0e135bddadb52.png";